import styled from 'styled-components'

export const ScrollIndicator = styled.div({
  position: 'absolute',
  bottom: '100px',
  right: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1202,
  pointerEvents: 'none'
})